import * as React from 'react';
import {Props} from './model';
import {UnreadNotificationsCounter} from '../../../counter';
import {Link} from '../../../link';
import {images} from '../../../../../assets/icons';
import {Routes, Screens} from '../../../../routing';
import {useTheme} from '../../../../theme';

export default ({navigation}: Props) => {
  const theme = useTheme();

  return (
    <Link
      testID='notification-widget-link-id'
      accessibilityLabel='Уведомления'
      href={Routes.mobileNotifications}
      screen={Screens.Notifications}
      navigate={navigation.navigate}
      dataSetClass='header-menu-link'>
      <UnreadNotificationsCounter>
        <images.Email height={24} width={24} color={theme.header.iconsColor} />
      </UnreadNotificationsCounter>
    </Link>
  );
};
